import React from 'react';

const DEFAULT_STATE = {};

export const AtualizaModeloInativoContext = React.createContext(DEFAULT_STATE);
